import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramArrow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramArrow';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { ArrowTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/ArrowTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const ManualModeDiagram = () => (
  <Diagram viewBox="0 0 340 110">
    <DiagramText x={170} y={22} tone={TextTone.MUTED} small tId="MANUAL_HINT_TOP" />
    {[
      { x: 10, label: '1º A' },
      { x: 130, label: '2º C' },
      { x: 250, label: '3º B' },
    ].map(({ x, label }) => (
      <g key={label}>
        <DiagramBox x={x} y={40} width={70} />
        <DiagramText x={x + 35} y={57}>
          {label}
        </DiagramText>
        <DiagramText x={x + 35} y={84} tone={TextTone.MAYBE} small bold tId="YOUR_TEAM">
          {'✍ '}
        </DiagramText>
      </g>
    ))}
    <DiagramArrow d="M80,53 L128,53" tone={ArrowTone.MUTED} dashed />
    <DiagramArrow d="M200,53 L248,53" tone={ArrowTone.MUTED} dashed />
    <DiagramText x={170} y={104} tone={TextTone.MUTED} small tId="MANUAL_HINT" />
  </Diagram>
);
